import React from "react";
import Navbar from "./Navbar";

function Privacy() {
  return (
    <div className="overflow-hidden bg-white">
      <div className="container-fluid pt-3 pb-3">
        <div className="container">
          {/* <Navbar /> */}

          <div className="row pb-5 mb-4">
            <div className="col-md-6">
              <a
                title="igesia logo"
                className="text-decoration-none text-light mr-3 text-uppercase text-s-9"
              >
                <img
                  src={`${process.env.PUBLIC_URL}/assets/Igesia-Logo.svg`}
                  height="60"
                />
              </a>
            </div>
          </div>

          <div className="text-dark">
            <p className="h1 mb-0">Igesia Privacy Statement</p>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="container">
          <div
            className="row pb-4"
            style={{ borderBottom: "1px solid rgba(255,255,255,0.2)" }}
          >
            <div className="col-md-10 text-dark">
              <div id="contents">
                <p class="c7">
                  <span class="c5 c11"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    When you purchase something from our store, as part of the
                    buying and selling process, we collect the personal
                    information you give us such as your name, address and email
                    address.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    When you browse our store, we also automatically receive
                    your computer’s internet protocol (IP) address in order to
                    provide us with information that helps us learn about your
                    browser and operating system.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    Email marketing (if applicable): With your permission, we
                    may send you emails about our store, new products and other
                    updates.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">SECTION 2 - CONSENT</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">How do you get my consent?</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    When you provide us with personal information to complete a
                    transaction, verify your credit card, place an order,
                    arrange for a delivery or return a purchase, we imply that
                    you consent to our collecting it and using it for that
                    specific reason only.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    If we ask for your personal information for a secondary
                    reason, like marketing, we will either ask you directly for
                    your expressed consent, or provide you with an opportunity
                    to say no.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">How do I withdraw my consent?</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c4">
                    If after you opt-in, you change your mind, you may withdraw
                    your consent for us to contact you, for the continued
                    collection, use or disclosure of your information, at
                    anytime, by contacting us at{" "}
                  </span>
                  <span class="c5">hello@igesia.co </span>
                  <span class="c4">or mailing us at: </span>
                  <span class="c5">
                    dePadmhe Technologies Pvt. Ltd., Gurgaon, Haryana - 122018
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">SECTION 3 - DISCLOSURE</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    We may disclose your personal information if we are required
                    by law to do so or if you violate our Terms of Service.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">SECTION 4 - PAYMENT</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    We use Razorpay for processing payments. We/Razorpay do not
                    store your card data on their servers. The data is encrypted
                    through the Payment Card Industry Data Security Standard
                    (PCI-DSS) when processing payment. Your purchase transaction
                    data is only used as long as is necessary to complete your
                    purchase transaction. After that is complete, your purchase
                    transaction information is not saved.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    Our payment gateway adheres to the standards set by PCI-DSS
                    as managed by the PCI Security Standards Council, which is a
                    joint effort of brands like Visa, MasterCard, American
                    Express and Discover.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    PCI-DSS requirements help ensure the secure handling of
                    credit card information by our store and its service
                    providers.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                {/* <p class="c2">
                  <span class="c4">
                    For more insight, you may also want to read terms and
                    conditions of razorpay on{" "}
                  </span>
                  <span class="c4 c10">
                    <a class="c3" href="https://igesia.co">
                      https://igesia.co
                    </a>
                  </span>
                </p> */}
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">SECTION 5 - THIRD-PARTY SERVICES</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    In general, the third-party providers used by us will only
                    collect, use and disclose your information to the extent
                    necessary to allow them to perform the services they provide
                    to us.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    However, certain third-party service providers, such as
                    payment gateways and other payment transaction processors,
                    have their own privacy policies in respect to the
                    information we are required to provide to them for your
                    purchase-related transactions.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    For these providers, we recommend that you read their
                    privacy policies so you can understand the manner in which
                    your personal information will be handled by these
                    providers.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    In particular, remember that certain providers may be
                    located in or have facilities that are located a different
                    jurisdiction than either you or us. So if you elect to
                    proceed with a transaction that involves the services of a
                    third-party service provider, then your information may
                    become subject to the laws of the jurisdiction(s) in which
                    that service provider or its facilities are located.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    Once you leave our store’s website or are redirected to a
                    third-party website or application, you are no longer
                    governed by this Privacy Policy or our website’s Terms of
                    Service.{" "}
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">Links</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    When you click on links on our store, they may direct you
                    away from our site. We are not responsible for the privacy
                    practices of other sites and encourage you to read their
                    privacy statements.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">SECTION 6 - SECURITY</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    To protect your personal information, we take reasonable
                    precautions and follow industry best practices to make sure
                    it is not inappropriately lost, misused, accessed,
                    disclosed, altered or destroyed.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">SECTION 7 - COOKIES</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    We use cookies to maintain session of your user. It is not
                    used to personally identify you on other websites.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">SECTION 8 - AGE OF CONSENT</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    &nbsp;By using this site, you represent that you are at
                    least the age of majority in your state or province of
                    residence, or that you are the age of majority in your state
                    or province of residence and you have given us your consent
                    to allow any of your minor dependents to use this site.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    SECTION 9 - CHANGES TO THIS PRIVACY POLICY
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    We reserve the right to modify this privacy policy at any
                    time, so please review it frequently. Changes and
                    clarifications will take effect immediately upon their
                    posting on the website. If we make material changes to this
                    policy, we will notify you here that it has been updated, so
                    that you are aware of what information we collect, how we
                    use it, and under what circumstances, if any, we use and/or
                    disclose it.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    If our store is acquired or merged with another company,
                    your information may be transferred to the new owners so
                    that we may continue to sell products to you.
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">QUESTIONS AND CONTACT INFORMATION</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c4">
                    If you would like to: access, correct, amend or delete any
                    personal information we have about you, register a
                    complaint, or simply want more information contact our
                    Privacy Compliance Officer at{" "}
                  </span>
                  <span class="c5">hello@igesia.co</span>
                  <span class="c4">or by mail at </span>
                  <span class="c5">
                    dePadmhe Technologies Pvt. Ltd., Gurgaon, Haryana - 122018
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">[Re: Privacy Compliance Officer]</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">
                    [dePadmhe Technologies Pvt. Ltd, Gurgaon, Haryana India
                    122018]
                  </span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c2">
                  <span class="c0">----</span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c1">
                  <span class="c0"></span>
                </p>
                <p class="c9">
                  <span class="c6"></span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
